import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import "./index.css";
import store from "./app/store";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import ScrollToTop from "./components/scrollToTop/ScrollToTop";
import { Env } from "./utils/enums";
import React, { Suspense } from "react";
import { FlagProvider } from "@unleash/proxy-client-react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

if (
  process.env.REACT_APP_NAME !== Env.DEV &&
  process.env.REACT_APP_NAME !== Env.DEV_MOBILE &&
  process.env.REACT_APP_NAME !== Env.UAT
) {
  console.log = () => {
    //
  };
}

caches?.keys().then((keys) => {
  return keys.map(async (cache) => {
    console.log("Service Worker: Removing old cache: " + cache);
    return await caches.delete(cache);
  });
});

const App = React.lazy(() => import("./App"));
const JourneyApp = React.lazy(() => import("./JourneyApp"));

const LazyApp = () => (
  <Suspense fallback={<></>}>
    {" "}
    <App />{" "}
  </Suspense>
);
const LazyJourneyApp = () => (
  <Suspense fallback={<></>}>
    {" "}
    <JourneyApp />{" "}
  </Suspense>
);

let config;

if (
  process.env.REACT_APP_UNLEASH_URL &&
  process.env.REACT_APP_UNLEASH_API_KEY
) {
  config = {
    url: process.env.REACT_APP_UNLEASH_URL,
    clientKey: process.env.REACT_APP_UNLEASH_API_KEY,
    refreshInterval: 120,
    appName: "IndusInd CardsHub"
  };
}

console.log(config);

const MainApp = () => (
  <BrowserRouter>
    <Provider store={store}>
      <ScrollToTop />
      <Routes>
        <Route path="/j/:page" element={<LazyJourneyApp />} />
        <Route path="*" element={<LazyApp />} />
      </Routes>
    </Provider>
  </BrowserRouter>
);

root.render(
  config ? (
    <FlagProvider config={config}>
      <MainApp />
    </FlagProvider>
  ) : (
    <MainApp />
  )
);

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
